export default __webpack_public_path__ + "static/media/contentful-logo.c827a19b.png";